import {
  Spinner,
  FormFeedback,
  Form,
  FormGroup,
  Label,
  Button,
  Input,
  ListGroup,
  ListGroupItem,
  UncontrolledTooltip,
  UncontrolledAccordion,
  AccordionHeader,
  AccordionBody,
  AccordionItem,
  Accordion,
} from "reactstrap";
import React, { useEffect, useState, useReducer, useRef } from "react";
import Select from "react-select";
import { OptionsContainer, Option, OptionImage } from "../product/style";
import {
  CoreContainer,
  DimensionInput,
  ExtensionInput,
  Icon,
} from "../common/style";
import _ from "lodash";
import { ProjectSettingsFormGroup } from "../project/style";
import { ExposedSidesLayout } from "../canvas";
import {
  addRemarksToOrderItem,
  getOrderItem,
  addAttachmentsToOrderItem,
  deleteAttachment,
  removeProjectOverride,
  deleteLight,
  clearRootSpace,
} from "../product/service";
import ConfirmationModal from "../project/ConfirmationModal";
import {
  UI_RESTRICTED_PROPERTIES,
  EXPO_COLOR_PROPERTIES,
  EDGE_COLOR_PROPERTIES,
} from "../constants";

const MultiUpdateModal = (props) => {
  const [properties, setProperties] = useState([]);
  const [productOptions, setProductOptions] = useState({});
  const [minMaxDimensions, setMinMaxDimensions] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [isRightPaneLoading, setIsRightPaneLoading] = useState(false);
  const [showUpdateConfirmation, setShowUpdateConfirmation] = useState(false);
  const [pendingChange, setPendingChange] = useState(null);
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [notificationMessage, setNotificationMessage] = useState({});
  const [showAttachmentForm, setShowAttachmentForm] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [label, setLabel] = useState("");
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [removeOverrideConfirmationOpen, setRemoveOverrideConfirmationOpen] =
    useState(false);
  const [overridePropertyIdentifier, setOverridePropertyIdentifier] =
    useState("");
  const [dimensions, setDimensions] = useState({
    height: "",
    width: "",
    depth: "",
  });
  const [carcassExtensions, setCarcassExtensions] = useState({});
  const hiddenFileInput = useRef(null);
  const [showRemoveGrooveConfirmation, setShowRemoveGrooveConfirmation] =
    useState(false);
  const [showClearSpaceConfirmation, setShowClearSpaceConfirmation] =
    useState(false);
  const [removeLight, setRemoveLight] = useState("");

  const handleToggleForm = () => {
    setShowAttachmentForm(!showAttachmentForm);
  };

  const handleCancel = () => {
    setShowAttachmentForm(false);
  };

  const toggleDeleteConfirmation = () =>
    setShowDeleteConfirmation(!showDeleteConfirmation);

  const toggleUpdateConfirmation = () =>
    setShowUpdateConfirmation(!showUpdateConfirmation);

  const toggleRemoveGrooveConfirmation = () => {
    setShowRemoveGrooveConfirmation(!showRemoveGrooveConfirmation);
    setRemoveLight("");
  };

  const toggleClearSpaceConfirmation = () => {
    setShowClearSpaceConfirmation(!showClearSpaceConfirmation);
  };
  const handleOptionsChangeWithConfirmation = (
    rootIdentifier,
    selectedOption
  ) => {
    if (checkShuttersOverrides() && rootIdentifier == "shutter_type") {
      setPendingChange({ rootIdentifier, selectedOption });
      toggleUpdateConfirmation();
    } else {
      handleOptionsChange(rootIdentifier, selectedOption);
    }
  };

  const confirmPendingChange = () => {
    if (pendingChange) {
      handleOptionsChange(
        pendingChange.rootIdentifier,
        pendingChange.selectedOption
      );
      setPendingChange(null);
      toggleUpdateConfirmation();
    }
  };

  const handleDeleteAttachment = (blobId) => {
    toggleDeleteConfirmation();

    return deleteAttachment({
      projectId: props.projectId,
      groupId: props.selectionManager.activeGroupId(),
      orderItemId: props.selectionManager.activeModuleId(),
      blobId,
    })
      .then(() => {
        reloadModule();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "error", message: error });
      });
  };

  const toggleOverrideConfirmation = () =>
    setRemoveOverrideConfirmationOpen(!removeOverrideConfirmationOpen);

  const handleAttachmentUpload = (file) => {
    addAttachmentsToOrderItem({
      projectId: props.projectId,
      groupId: props.selectionManager.activeGroupId(),
      orderItemId: props.selectionManager.activeModuleId(),
      image: file,
      label,
    })
      .catch(({ error }) => {
        setNotificationMessage({
          text: error,
          type: "danger",
        });
      })
      .finally(() => {
        reloadModule();
        setLabel("");
        setShowAttachmentForm(false);
      });
  };

  const prepareForModuleEditing = () => {
    const orderItem = props.selectionManager.selectedModule();

    setAttachments(orderItem.attachments || []);
    setRemarks(orderItem.remarks || "");
  };

  const [oldDimensions, setOldDimensions] = useState({
    height: "",
    width: "",
    depth: "",
  });
  const skipProperties = [
    "exposed_side_left",
    "exposed_side_right",
    "exposed_side_top",
    "exposed_side_bottom",
    "exposed_side_back",
  ];
  const propertyIdentifiers = [
    "frame_depth",
    "color",
    "shutter_type",
    "profile_type",
    "profile_handle_type",
    "profile_color",
    "profile_glass_type",
    "profile_handle_position"];

  const shutterColorProperty = propertyIdentifiers
    .map((identifier) =>
      properties.find((property) => property.identifier === identifier)
    )
    .filter((property) => property !== undefined);

  const grouped_properties = props.modules[0].grouped_properties;
  const userProperties = properties.filter(
    (property) => !property.admin_property
  );

  const adminProperties = properties.filter(
    (property) => property.admin_property
  );

  const modules = props.modules;
  const allProperties = Array.isArray(modules)
    ? modules.map((m) => m.property_list).flat()
    : modules.property_list || [];
  const uniqPropertyIdentifiers = [
    ...new Set(allProperties.map((e) => e.identifier)),
  ].filter((identifier) => !skipProperties.includes(identifier));
  const uniqPropertyUniqIds = [
    ...new Set(allProperties.map((e) => e.uniq_id)),
  ].filter((identifier) => !skipProperties.includes(identifier));

  function getProperties() {
    return uniqPropertyIdentifiers.map((identifier) => {
      const properties = allProperties.filter(
        (e) => e.identifier === identifier
      );
      const options = properties.map((e) => e.options).flat();

      const groupedOption = options.reduce((acc, value) => {
        if (!acc[value.identifier]) acc[value.identifier] = [];
        acc[value.identifier].push(value);

        return acc;
      }, {});

      const commonOptions = Object.keys(groupedOption)
        .filter((identifier) => {
          return groupedOption[identifier].length === properties.length;
        })
        .map((identifier) => {
          return groupedOption[identifier][0];
        });

      const uniqProperty = properties[0];

      const allOverriddenValues = properties.map((p) => p.is_overridden);

      const isAllSame = allOverriddenValues.every(
        (val) => val === allOverriddenValues[0]
      );

      uniqProperty.is_overridden = isAllSame ? allOverriddenValues[0] : false;
      uniqProperty.options = commonOptions;

      return uniqProperty;
    });
  }

  function getCommonSelectedValues(modules, identifiers) {
    const selectedValues = {};

    identifiers.forEach((identifier) => {
      const values = getSelectedValuesForOrderItems(modules, identifier).map(
        (e) => e[identifier]
      );
      if ([...new Set(values)].length === 1 && values[0] !== undefined)
        selectedValues[identifier] = values[0];
    });

    return selectedValues;
  }

  const getClassForRenderingProperties = ({ headers, displayType }) => {
    if (headers === "null") return "";

    return displayType === "toggle"
      ? "rounded-1 mt-2 btn-group"
      : "d-flex align-items-center flex-wrap gap-10";
  };

  function getSelectedValuesForOrderItems(modules, identifier) {
    const modulesArray = Array.isArray(modules) ? modules : [modules];

    return modulesArray
      .filter((e) => {
        if (e.property_list.map((e) => e.uniq_id).includes(identifier)) {
          return e.selected_values;
        }
      })
      .map((module) => module.selected_values);
  }

  function getMinMax(modules, key) {
    if (!Array.isArray(modules)) {
      const dimension = modules.all_dimensions.find((e) => e.key === key);
      return { minValue: dimension.min_value, maxValue: dimension.max_value };
    }

    const minValue = Math.max(
      ...modules.map(
        (m) => m.all_dimensions.find((e) => e.key === key).min_value
      )
    );
    const maxValue = Math.min(
      ...modules.map(
        (m) => m.all_dimensions.find((e) => e.key === key).max_value
      )
    );

    return { minValue, maxValue };
  }

  function getDimensions(modules) {
    const height = getMinMax(modules, "height");
    const width = getMinMax(modules, "width");
    const depth = getMinMax(modules, "depth");

    return [
      {
        identifier: "height",
        name: "Height",
        ...getMinMaxRange(height.minValue, height.maxValue),
      },
      {
        identifier: "width",
        name: "Width",
        ...getMinMaxRange(width.minValue, width.maxValue),
      },
      {
        identifier: "depth",
        name: "Depth",
        ...getMinMaxRange(depth.minValue, depth.maxValue),
      },
    ];
  }

  function getMinMaxRange(minValue, maxValue) {
    const inRange = minValue <= maxValue;

    return {
      minValue: inRange ? minValue : null,
      maxValue: inRange ? maxValue : null,
    };
  }
  useEffect(() => {
    props.setErrorMessage("");
    props.setChangedProperty("");
  }, [props.selectionManager.getKey()]);

  useEffect(() => {
    if (!props.hasMoreThanTwoItems) {
      prepareForModuleEditing();
    }

    const dimension = {};

    if (Array.isArray(modules)) {
      if (modules.length === 1) {
        dimension["height"] = modules[0].dimensions.height;
        dimension["width"] = modules[0].dimensions.width;
        dimension["depth"] = modules[0].dimensions.depth;
      } else {
        if ([...new Set(modules.map((e) => e.dimensions.height))].length === 1)
          dimension["height"] = modules[0].dimensions.height;
        if ([...new Set(modules.map((e) => e.dimensions.width))].length === 1)
          dimension["width"] = modules[0].dimensions.width;
        if ([...new Set(modules.map((e) => e.dimensions.depth))].length === 1)
          dimension["depth"] = modules[0].dimensions.depth;
      }
    } else {
      dimension["height"] = modules.dimensions.height;
      dimension["width"] = modules.dimensions.width;
      dimension["depth"] = modules.dimensions.depth;
    }

    setProperties(getProperties());
    setProductOptions(getCommonSelectedValues(modules, uniqPropertyUniqIds));
    setMinMaxDimensions(getDimensions(modules));
    setDimensions({
      height: props.invalidDimension.height || dimension.height || "",
      width: props.invalidDimension.width || dimension.width || "",
      depth: props.invalidDimension.depth || dimension.depth || "",
    });
    setOldDimensions({
      height: dimension.height || "",
      width: dimension.width || "",
      depth: dimension.depth || "",
    });
    setCarcassExtensions(
      Array.isArray(modules)
        ? modules.length === 1
          ? modules[0].carcass_extensions
          : { left: {}, right: {}, top: {}, bottom: {} }
        : modules.carcass_extensions
    );
  }, [props.modules]);

  const reloadModule = () => {
    setIsRightPaneLoading(true);

    getOrderItem({
      projectId: props.projectId,
      groupId: props.selectionManager.activeGroupId(),
      orderItemId: props.selectionManager.activeModuleId(),
      version: "v2",
    })
      .then((orderItem) => {
        replaceModule(orderItem);
      })
      .catch(({ error }) => {
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally((_) => {
        setIsRightPaneLoading(false);
      });
  };

  const replaceModule = (updatedModule) => {
    populateGroupedProperties(updatedModule);
    const module = props.selectionManager.findModule(updatedModule.id);

    Object.assign(module, updatedModule);
    setAttachments(module.attachments);
    setRemarks(module.remarks);
    forceUpdate();
  };

  const populateGroupedProperties = (orderItem) => {
    if (orderItem.is_old_mode) return;

    if (!orderItem.isPrepared) {
      const groupedProperties = _.groupBy(
        orderItem.property_list.filter(
          (property) =>
            !(
              UI_RESTRICTED_PROPERTIES.includes(property.uniq_id) ||
              orderItem.project_settings[property.uniq_id]
            )
        ),
        "header_name"
      );

      orderItem.groupedProperties = groupedProperties;
      orderItem.isPrepared = true;
    }
  };

  const handleOptionsChange = (rootIdentifier, optionIdentifier) => {
    const orderItemIds = Array.isArray(props.modules)
      ? props.modules
          .filter((module) =>
            module.property_list?.some(
              (prop) =>
                prop.identifier === rootIdentifier ||
                prop.uniq_id === rootIdentifier
            )
          )
          .map((e) => e.id)
      : props.modules.property_list?.some(
          (prop) =>
            prop.identifier === rootIdentifier ||
            prop.uniq_id === rootIdentifier
        )
      ? [props.modules.id]
      : [];

    props.updateProperties({
      orderItemIds,
      properties: { [rootIdentifier]: optionIdentifier },
    });
  };

  const handleRemarks = () => {
    setIsRightPaneLoading(true);

    addRemarksToOrderItem({
      projectId: props.projectId,
      groupId: props.selectionManager.activeGroupId(),
      orderItemId: props.selectionManager.activeModuleId(),
      remarks,
    })
      .catch(({ error }) => {
        setNotificationMessage({
          text: error,
          type: "danger",
        });
      })
      .finally(() => {
        setIsRightPaneLoading(false);
        reloadModule();
      });
  };

  const renderProperty = (property) => {
    const selectedOption = property.options.find((option) => option.selected);

    const productOptionExists = property.options.find(
      (option) => option.identifier === productOptions[property.uniq_id]
    );
    if (!property.options.length) return null;

    return (
      <>
        {property.is_editable ? (
          <Select
            value={
              property.options.find(
                (option) =>
                  option.identifier === productOptions[property.uniq_id]
              ) || null
            }
            isDisabled={!property.is_editable}
            className="mt-1"
            options={property.options.map((option, index) => {
              option.value = option.name;
              option.label = option.image ? (
                <div key={index}>
                  {option.image && (
                    <OptionImage
                      key={index}
                      src={option.image}
                      alt={option.name}
                      className="me-2 border border-dark rounded-circle"
                    />
                  )}
                  {option.name}
                </div>
              ) : (
                option.name
              );
              option.key = index;

              return {
                value: option.name,
                label: option.name,
                ...option,
              };
            })}
            onChange={(selectedOption) => {
              property.is_editable &&
                handleOptionsChangeWithConfirmation(
                  property.uniq_id,
                  selectedOption.identifier
                );
            }}
          />
        ) : (
          property.is_editable && (
            <div
              className="mt-1 text-disabled"
              title={"Switch to table view to change this setting"}
            >
              {property.options.find(
                (option) =>
                  option.identifier === productOptions[property.uniq_id]
              )?.name || null}
            </div>
          )
        )}

        {!property.is_editable && (
          <div className="mt-1 text-disabled">
            {property.options.find(
              (option) => option.identifier === productOptions[property.uniq_id]
            )?.name || null}
          </div>
        )}
        {props.projectSettings[property.uniq_id] &&
        !props.projectSettings[property.uniq_id]?.mandatory &&
        selectedOption ? (
          <div
            className="mt-1 fs-10px"
            style={{ color: "#999999" }}
            title={"Using Project Setting"}
            data-toggle="tooltip"
            data-delay="0"
          >
            <i className="fa-solid fa-gear me-1" />
            <span>{selectedOption.name}</span>
          </div>
        ) : (
          !property.is_editable &&
          props.hasMoreThanTwoItems &&
          !productOptionExists && (
            <div className="mt-1 fs-10px" style={{ color: "#999999" }}>
              <span>Multiple Values</span>
            </div>
          )
        )}
        {!props.projectSettings[property.uniq_id]?.mandatory &&
        EXPO_COLOR_PROPERTIES.includes(property.uniq_id) ? (
          <div className="mt-1 fs-10px" style={{ color: "#999999" }}>
            <span>Using outer lam</span>
          </div>
        ) : !props.projectSettings[property.uniq_id]?.mandatory &&
          EDGE_COLOR_PROPERTIES.includes(property.uniq_id) ? (
          <div className="mt-1 fs-10px" style={{ color: "#999999" }}>
            <span>Using inner lam</span>
          </div>
        ) : null}
      </>
    );
  };

  const ExpoPropertySection = ({ selectionManager, hasMoreThanTwoItems }) => {
    if (hasMoreThanTwoItems) return null;

    const groupedProperties =
      selectionManager.activeModule()?.groupedProperties;
    const expoModule = selectionManager.selectedModule();
    const moduleExposedSides = expoModule.customizations.exposed_sides;
    const hasExpoSides =
      moduleExposedSides &&
      moduleExposedSides.filter((side) => side !== null).length > 0;

    if (!groupedProperties?.["Exposed Sides"]) return null;

    const exposedSides = groupedProperties["Exposed Sides"];
    const displayType = exposedSides[0]?.display_type;
    const isReadOnly = _.some(exposedSides, "read_only");

    return (
      <div className="pb-2 expo">
        <p className="fs-10px m-0 fw-bold text-capitalize">Expo</p>
        <div
          id={isReadOnly && "expo_disabled"}
          className={getClassForRenderingProperties({
            headers: "Exposed Sides",
            displayType,
          })}
        >
          {exposedSides.map((header) => {
            if (displayType === "toggle" && props.access.update_property) {
              const [option1, option2] = header.options;
              option1.level = 1;
              option2.level = 1;

              return (
                <Option
                  disabled={header.read_only}
                  key={header.uniq_id}
                  className={`default-option ${
                    option1.selected && !option1.fromProjectSettings
                      ? "selected-option"
                      : ""
                  }`}
                  onClick={() => {
                    if (props.access.update_property) {
                      handleOptionsChange(
                        header.uniq_id,
                        option1.selected
                          ? option2.identifier
                          : option1.identifier
                      );
                    }
                  }}
                >
                  {header.name.replace("Exposed Side ", "")}
                </Option>
              );
            }
            return null;
          })}
          {!props.access.update_property &&
            (hasExpoSides ? (
              <ExposedSidesLayout exposedSides={moduleExposedSides} />
            ) : (
              <div className="mb-1" style={{ color: "#999999" }}>
                None
              </div>
            ))}
        </div>
        {isReadOnly && (
          <UncontrolledTooltip target="expo_disabled" placement="bottom">
            Expo cannot be changed for this module.
          </UncontrolledTooltip>
        )}
      </div>
    );
  };

  const handleRemoveProjectOverride = (propertyIdentifier) => {
    setIsRightPaneLoading(true);
    removeProjectOverride({
      projectId: props.projectId,
      groupId: props.selectionManager.activeGroupId(),
      orderItemIds: props.selectionManager.selectionIds(),
      propertyIdentifier: propertyIdentifier,
    })
      .then((orderItems) => {
        orderItems.forEach((o) => props.replaceModule(o));
        props.refreshProjectSummary();
      })
      .catch((error) => {
        setIsNotificationVisible(true);
        setNotificationMessage({
          type: "error",
          message: error?.message,
        });
      })
      .finally(() => {
        toggleOverrideConfirmation();
        setIsRightPaneLoading(false);
      });
  };

  const handleBlur = async (dimension) => {
    try {
      await updateDimension(dimension.identifier, {
        minValue: dimension.minValue,
        maxValue: dimension.maxValue,
      });
      setDimensions((prevDimensions) => ({
        ...prevDimensions,
        [dimension.identifier]: dimensions[dimension.identifier],
      }));
    } catch (error) {
      console.error("Error updating dimension:", error);
    }
  };

  const handleExtensionsBlur = async () => {
    try {
      props.updateProperties({
        orderItemIds: Array.isArray(props.modules)
          ? props.modules.map((e) => e.id)
          : [props.modules.id],
        carcassExtensions: { ...carcassExtensions },
      });
    } catch (error) {
      console.error("Error updating extensions:", error);
    }
  };

  const renderRemarks = () => {
    // Don't show remarks for multi-select.
    if (props.hasMoreThanTwoItems) return null;

    if (!props.access.update_property) {
      return (
        <div className="pb-2">
          <Label
            for="Remarks"
            className="mb-1 d-inline fw-bold text-capitalize"
          >
            <span>Remarks</span>
          </Label>
          <div
            style={{
              color: remarks ? "inherit" : "grey",
            }}
          >
            {remarks || "None"}
          </div>
        </div>
      );
    }
    return (
      <div className="pb-3 mb-2">
        <Label
          for="Remarks"
          className="fs-10px m-0 d-inline fw-bold text-capitalize"
        >
          <span>Remarks</span>
        </Label>
        <Input
          id="Remarks"
          name="text"
          type="textarea"
          disabled={!props.access.update_property}
          placeholder="Type your remarks here"
          value={remarks || ""}
          onChange={(e) => setRemarks(e.target.value)}
          onBlur={handleRemarks}
          onKeyDown={(e) => {
            e.key == "Enter" && !e.shiftKey && handleRemarks();
          }}
          className="mt-1"
          style={{ fontSize: "12px" }}
        />
        <div className="text-secondary mt-1">
          Press Shift + Enter for adding multiple lines
        </div>
      </div>
    );
  };

  const renderCarcassExtensions = () => {
    return (
      <div className="d-flex flex-column row-gap-3">
        {Object.keys(carcassExtensions).map(
          (panelName, index) =>
            carcassExtensions[panelName] &&
            panelName !== "disabled_options" &&
            !_.isEmpty(carcassExtensions[panelName]) && (
              <div key={index}>
                <span
                  className={
                    "less-subtle-gay fs-10px m-0 d-inline fw-bold text-capitalize"
                  }
                >
                  Carcass {panelName} Extension
                </span>
                <Form className="d-flex gap-3">
                  {Object.keys(carcassExtensions[panelName]).map(
                    (directionName, index) => (
                      <ProjectSettingsFormGroup key={index}>
                        <p className="m-0 d-inline text-capitalize subtle-gray fs-12px">
                          {directionName}
                        </p>
                        <ExtensionInput
                          type={"number"}
                          value={carcassExtensions[panelName][directionName]}
                          onChange={(ev) => {
                            setCarcassExtensions({
                              ...carcassExtensions,
                              [panelName]: {
                                ...carcassExtensions[panelName],
                                [directionName]:
                                  parseInt(ev.target.value) || null,
                              },
                            });
                          }}
                          onBlur={() => handleExtensionsBlur()}
                          onKeyDown={(e) => {
                            e.key == "Enter" && handleExtensionsBlur();
                          }}
                          disabled={
                            !props.access.update_property ||
                            (carcassExtensions.disabled_options[panelName] &&
                              carcassExtensions.disabled_options[panelName][
                                directionName
                              ])
                          }
                          className="mt-1"
                          invalid={
                            !(
                              carcassExtensions[panelName][directionName] >=
                                0 &&
                              carcassExtensions[panelName][directionName] <= 150
                            )
                          }
                          placeholder={
                            carcassExtensions[panelName][directionName] > 1000
                          }
                          title={`Carcass Left Panel ${directionName} Extension`}
                        />
                        <FormFeedback invalid>
                          {carcassExtensions[panelName][directionName] > 150
                            ? "Max 150mm"
                            : "Invalid Input"}
                        </FormFeedback>
                      </ProjectSettingsFormGroup>
                    )
                  )}
                </Form>
              </div>
            )
        )}
      </div>
    );
  };

  const checkShuttersOverrides = () => {
    let hasOverrides = false;

    props.modules.map((mod, index) => {
      if (
        mod.template.shutters.some(
          (shutter) => Object.keys(shutter.overrides).length > 0
        )
      ) {
        hasOverrides = true;
      }
    });

    return hasOverrides;
  };

  const renderPropertyBlock = (properties) => {
    return properties.map((property, index) => {
      return (
        <>
          <div
            id={`property_${property.identifier}`}
            key={index}
            className={`property-block ${
              (property.automated_by || property.depends_on) && "disabled"
            } ${!property.is_editable && "pointer"}`}
          >
            <div className="d-flex justify-content-between align-items-center">
              <p className="fs-10px m-0 d-inline fw-bold text-capitalize">
                {property.name}
              </p>
              {property.is_editable && property.is_overridden && (
                <>
                  <span
                    id={`clear_${property.uniq_id}`}
                    className="d-flex align-items-center justify-content-center mt-1 pointer fs-11px"
                    onClick={() => {
                      property.is_editable && toggleOverrideConfirmation();
                      property.is_editable &&
                        setOverridePropertyIdentifier(property.uniq_id);
                    }}
                    style={{
                      textDecoration: "none",
                      marginLeft: "10px",
                    }}
                  >
                    <i className="fa-solid fa-rotate-left me-1"></i>
                    <span>clear</span>
                  </span>
                  <UncontrolledTooltip
                    target={`clear_${property.uniq_id}`}
                    placement="left"
                  >
                    Clear and use project setting
                  </UncontrolledTooltip>
                </>
              )}
            </div>
            {renderProperty(property)}
          </div>
          {property.uniq_id === props.changedProperty && props.errorMessage && (
            <div className="text-danger fs-10px">{props.errorMessage}</div>
          )}
          {property.automated_by && (
            <UncontrolledTooltip
              target={`property_${property.identifier}`}
              placement="bottom"
            >
              Automated by <i>{property.automated_by}</i>
            </UncontrolledTooltip>
          )}
          {property.depends_on && (
            <UncontrolledTooltip
              target={`property_${property.identifier}`}
              placement="bottom"
            >
              To enable this, enable <i>{property.depends_on}</i>
            </UncontrolledTooltip>
          )}
        </>
      );
    });
  };

  const isDimensionNotValid = (dimension) => {
    return (
      dimension.length > 0 &&
      (!/^\d*$/.test(dimension) ||
        parseInt(dimension) < 1 ||
        parseInt(dimension) > 2400)
    );
  };

  const updateDimension = (identifier, dimensionRange) => {
    const dimensionValue = dimensions[identifier];
    const oldDimensionValue = oldDimensions[identifier];
    const invalid = isDimensionNotValid(dimensionValue, dimensionRange);

    if (
      dimensionValue == oldDimensionValue ||
      dimensionValue == "" ||
      invalid
    ) {
      setDimensions({
        ...dimensions,
        [identifier]: oldDimensionValue,
      });
      return;
    }

    props.updateProperties({
      orderItemIds: Array.isArray(props.modules)
        ? props.modules.map((e) => e.id)
        : [props.modules.id],
      dimensions: { [identifier]: dimensionValue },
    });
  };

  const deleteGroove = (uniqId) => {
    props.setIsLoading(true);

    deleteLight({
      projectId: props.projectId,
      orderItemId: props.selectionManager.activeModuleId(),
      uniqId,
    })
      .then((orderItem) => {
        props.replaceModule(orderItem);
        props.refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({
          type: "danger",
          text: error,
        });
      })
      .finally(() => props.setIsLoading(false));
  };

  const handleClearRootSpace = () => {
    props.setIsLoading(true);

    clearRootSpace({
      projectId: props.projectId,
      groupId: props.selectionManager.activeGroupId(),
      orderItemId: props.selectionManager.activeModuleId(),
    })
      .then((orderItem) => {
        props.replaceModule(orderItem);
        props.refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({
          type: "danger",
          text: error,
        });
      })
      .finally(() => {
        props.setIsLoading(false);
        toggleClearSpaceConfirmation();
      });
  };

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  return properties.length === 0 ? (
    <CoreContainer>
      <Spinner>Loading...</Spinner>
    </CoreContainer>
  ) : (
    <>
      {notificationMessage.text && (
        <Notification
          color={notificationMessage.type}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notificationMessage.text}
        </Notification>
      )}
      <div className="pb-5 properties-tab">
        {props.activePropertyTab === "user" ? (
          <>
            {!props.isListProject && (
              <div className="px-3">
                <div>
                  {props.access.update_property ? (
                    <Form className="d-flex gap-2 pb-2">
                      {minMaxDimensions.map((dimension, index) => (
                        <ProjectSettingsFormGroup key={index}>
                          <p className="fs-10px m-0 d-inline fw-bold text-capitalize">
                            {dimension.name}
                          </p>
                          <DimensionInput
                            value={dimensions[dimension.identifier]}
                            onChange={(ev) =>
                              setDimensions({
                                ...dimensions,
                                [dimension.identifier]: ev.target.value,
                              })
                            }
                            onBlur={() => handleBlur(dimension)}
                            onKeyDown={(e) => {
                              e.key == "Enter" && handleBlur(dimension);
                            }}
                            disabled={
                              !dimension.minValue ||
                              !props.access.update_property ||
                              dimension.minValue == dimension.maxValue
                            }
                            className="mt-1 abcd"
                            invalid={
                              props.invalidDimension[dimension.identifier] ||
                              isDimensionNotValid(
                                dimensions[dimension.identifier],
                                {
                                  minValue: 1,
                                  maxValue: 2400,
                                }
                              )
                            }
                            placeholder={!dimension.minValue && "N/A"}
                            title={
                              !dimension.minValue
                                ? `Selected cabinets don't have a common ${dimension.identifier} option`
                                : ""
                            }
                          />
                          <FormFeedback invalid>
                            {props.invalidDimension[dimension.identifier]
                              ? "Invalid"
                              : "1 to 2400"}
                          </FormFeedback>
                        </ProjectSettingsFormGroup>
                      ))}
                    </Form>
                  ) : (
                    <div className="pb-3 d-flex flex-column">
                      <p className="mb-1 d-inline fw-bold text-capitalize">
                        dimension
                      </p>
                      <div>
                        <span>{dimensions.height}</span>
                        <span className="grey_letter me-2"> H</span>
                        <span>{dimensions.width}</span>
                        <span className="grey_letter me-2"> W</span>
                        <span>{dimensions.depth}</span>
                        <span className="grey_letter"> D</span>
                      </div>
                    </div>
                  )}
                </div>

                {shutterColorProperty.map((property, index) => {
                  return (
                    <>
                      <div className="pb-2" key={index}>
                        <p className="fs-10px m-0 d-inline fw-bold text-capitalize">
                          {property.name}
                        </p>
                        {renderProperty(property)}
                      </div>
                      {property.uniq_id === props.changedProperty &&
                        props.errorMessage && (
                          <div className="text-danger fs-10px pb-1 m-1">
                            {props.errorMessage}
                          </div>
                        )}
                    </>
                  );
                })}

                <ExpoPropertySection
                  selectionManager={props.selectionManager}
                  hasMoreThanTwoItems={props.hasMoreThanTwoItems}
                />

                {props.selectionManager.selections().length === 1 &&
                  props.selectionManager.selections()[0].type === "module" &&
                  props.selectionManager.selections()[0].template
                    .root_space && (
                    <div className={"mb-2 mt-1"}>
                      <Button
                        color="secondary"
                        size="sm"
                        onClick={() => setShowClearSpaceConfirmation(true)}
                        disabled={!props.access.update_module}
                      >
                        Clear Internals
                      </Button>
                    </div>
                  )}

                {userProperties.some(
                  (property) =>
                    props.projectSettings[property.uniq_id]?.mandatory
                ) && (
                  <div className="d-flex flex-column row-gap-3 mb-2">
                    {renderPropertyBlock(
                      userProperties.filter(
                        (property) =>
                          props.projectSettings[property.uniq_id]?.mandatory
                      )
                    )}
                  </div>
                )}
              </div>
            )}

            {!props.isListProject ? (
              <div className="border-top">
                {Object.entries(grouped_properties).map(
                  ([header, identifiers]) => {
                    const propertiesList = identifiers
                      .map((identifier) =>
                        properties.find((e) => e.identifier == identifier)
                      )
                      .filter((e) => e);

                    if (
                      propertiesList.length ===
                      propertiesList.filter(
                        (property) =>
                          props.projectSettings[property.uniq_id]?.mandatory
                      ).length
                    )
                      return;

                    return (
                      <div className="border-bottom">
                        <UncontrolledAccordion stayOpen>
                          <AccordionItem key={header} className="padded">
                            <AccordionHeader targetId={header}>
                              <div className="d-flex flex-row-reverse">
                                <p className="m-0 fs-10px fw-bold active-dimension text-uppercase">
                                  {header}
                                </p>
                              </div>
                            </AccordionHeader>
                            <AccordionBody accordionId={header}>
                              {renderPropertyBlock(
                                propertiesList.filter(
                                  (property) =>
                                    !props.projectSettings[property.uniq_id]
                                      ?.mandatory
                                )
                              )}
                              {header === "build" && (
                                <div>{renderCarcassExtensions()}</div>
                              )}
                            </AccordionBody>
                          </AccordionItem>
                        </UncontrolledAccordion>
                      </div>
                    );
                  }
                )}
              </div>
            ) : (
              !props.hasMoreThanTwoItems && (
                <UncontrolledAccordion>
                  <AccordionItem key="extensions" className="padded">
                    <AccordionHeader targetId="extensions">
                      <div className="d-flex flex-row-reverse">
                        <p className="m-0 fs-10px fw-bold active-dimension text-uppercase">
                          Extensions
                        </p>
                      </div>
                    </AccordionHeader>
                    <AccordionBody accordionId="extensions">
                      {renderCarcassExtensions()}
                    </AccordionBody>
                  </AccordionItem>
                </UncontrolledAccordion>
              )
            )}

            {!props.hasMoreThanTwoItems &&
              props.selectionManager.selectedModule().is_light_eligible && (
                <div className="border-bottom grooves_section">
                  <Accordion
                    open={props.openLightGroove}
                    toggle={props.toggleLightGroove}
                  >
                    <AccordionItem key="grooves" className="padded">
                      <AccordionHeader targetId="grooves">
                        <div className="d-flex flex-row-reverse">
                          <p className="m-0 fs-10px fw-bold active-dimension text-uppercase">
                            Lights
                          </p>
                        </div>
                      </AccordionHeader>
                      <AccordionBody accordionId="grooves">
                        {props.selectionManager.selectedModule().lights
                          .length === 0 ? (
                          <div className="py-4 border-top">
                            <p className="m-0 grey_text text-center">
                              No lights added
                            </p>
                          </div>
                        ) : (
                          props.selectionManager
                            .selectedModule()
                            .lights.map((e, index) => (
                              <div
                                key={index}
                                className="d-flex flex-column row-gap-3 border-top py-2"
                              >
                                <div className="d-flex align-items-center justify-content-between px-3">
                                  <div className="d-flex align-items-center column-gap-2">
                                    <p className="m-0 grey_letter">Model</p>
                                    <p className="m-0">{e.model.name}</p>
                                  </div>
                                  {props.access.can_edit_project && (
                                    <div className="d-flex align-items-center column-gap-2">
                                      <i
                                        className="fa-regular fa-pen-to-square fs-6 pointer grey_text"
                                        onClick={() => {
                                          props.setShowLightForm(true);
                                          props.setLightInfo({
                                            action: "update",
                                            uniqId: e.uniq_id,
                                            model: e.model.value,
                                            offset: e.offset,
                                            from: e.near,
                                            onSide: e.on_side,
                                            selectedSides: e.sides,
                                          });
                                        }}
                                      ></i>
                                      <i
                                        className="fa-regular fa-trash-can fs-6 pointer grey_text"
                                        onClick={() => {
                                          setShowRemoveGrooveConfirmation(true);
                                          setRemoveLight(e.uniq_id);
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                                <div className="d-flex align-items-center column-gap-2 px-3">
                                  <p className="m-0 grey_letter">Position</p>
                                  <p className="m-0">{e.offset + "mm"}</p>
                                  <p className="m-0 grey_letter">from</p>
                                  <p className="m-0">{e.near}</p>
                                </div>
                                <div className="d-flex align-items-center column-gap-2 px-3">
                                  <p className="m-0 grey_letter">Side</p>
                                  <p className="m-0 text-capitalize">
                                    {e.on_side}
                                  </p>
                                  <div className="d-flex align-items-center column-gap-1">
                                    {e.sides.map((side, sideIndex) => (
                                      <span
                                        key={sideIndex}
                                        style={{
                                          height: "18px",
                                          width: "18px",
                                        }}
                                        className="border border-black rounded-circle text-capitalize text-center"
                                      >
                                        {side[0]}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            ))
                        )}
                        {props.access.can_edit_project && (
                          <div className="d-flex border-top py-2 px-3">
                            <div
                              className="d-flex align-items-center column-gap-2 active-dimension pointer"
                              onClick={() => {
                                props.setShowLightForm(true);
                                props.setLightInfo({
                                  action: "add",
                                });
                              }}
                            >
                              <i className="fa-solid fa-circle-plus" />
                              <p className="m-0">Add Light</p>
                            </div>
                          </div>
                        )}
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                </div>
              )}

            <div className="px-3 pt-3">{renderRemarks()}</div>

            {!props.hasMoreThanTwoItems && (
              <div className="px-3">
                <p className="m-0 d-inline pb-2 fw-bold text-capitalize">
                  <span>Attachments</span>
                </p>

                {attachments.length > 0 ? (
                  <div className="mt-1">
                    <ListGroup numbered flush>
                      {attachments.map((attachment, index) => (
                        <ListGroupItem
                          key={index}
                          className="d-flex align-items-center"
                        >
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <span className="ms-1" style={{ width: "130px" }}>
                              {attachment.filename}
                            </span>

                            <div>
                              <a href={attachment.url}>
                                <Icon className="fa-solid fa-download pointer" />
                              </a>

                              {showDeleteConfirmation && (
                                <ConfirmationModal
                                  isOpen={showDeleteConfirmation}
                                  toggle={toggleDeleteConfirmation}
                                  onConfirm={() =>
                                    handleDeleteAttachment(attachment.id)
                                  }
                                  message="Are sure you want to delete this Attachment?"
                                  headingText="Confirm Deletion"
                                />
                              )}

                              {props.access.update_property && (
                                <Icon
                                  className="fa-regular fa-trash-can ms-3 pointer"
                                  size="16px"
                                  title="Delete Attachment"
                                  onClick={toggleDeleteConfirmation}
                                />
                              )}
                            </div>
                          </div>
                        </ListGroupItem>
                      ))}
                    </ListGroup>
                  </div>
                ) : (
                  <span
                    className="d-flex justify-content-left mt-1"
                    style={{ color: "#999999" }}
                  >
                    {!isRightPaneLoading
                      ? "No Attachments!"
                      : "Loading Attachments..."}
                  </span>
                )}
                {showAttachmentForm && (
                  <Form>
                    <FormGroup className="mt-3 d-flex justify-content-space-between">
                      <Input
                        id="label"
                        name="label"
                        type="text"
                        placeholder="Label"
                        value={label}
                        className="me-3 w-50"
                        onChange={(e) => setLabel(e.target.value)}
                      />
                      <div className="d-flex align-items-end justify-content-space-between">
                        <Label for="attachments" className="mb-0">
                          <Button
                            className="btn btn-success pointer d-flex"
                            disabled={!label || !props.access.update_property}
                            onClick={() => hiddenFileInput.current.click()}
                          >
                            <span className="fw-bold">Upload</span>
                            <Icon className="fa-solid fa-upload pointer ms-3 d-flex justify-content-center " />
                          </Button>
                        </Label>
                        <Input
                          id="attachments"
                          name="file"
                          type="file"
                          disabled={!label}
                          accept="image/*,.pdf"
                          className="d-none"
                          innerRef={hiddenFileInput}
                          onChange={(e) => {
                            handleAttachmentUpload(e.target.files[0]);
                          }}
                        />
                        <a onClick={handleCancel} className="ms-3 pointer">
                          Cancel
                        </a>
                      </div>
                    </FormGroup>
                  </Form>
                )}
                {props.access.update_property && (
                  <div className="p-2 ps-0 d-flex mt-1">
                    <Button
                      disabled={!props.access.update_property}
                      onClick={props.isDesigner && handleToggleForm}
                      outline
                      size="sm"
                    >
                      <i className="fa-solid fa-circle-plus me-2"></i>
                      Add Attachment
                    </Button>
                  </div>
                )}
              </div>
            )}
          </>
        ) : (
          <div className="d-flex flex-column px-3 row-gap-3">
            {renderPropertyBlock(adminProperties)}
          </div>
        )}

        <ConfirmationModal
          isOpen={removeOverrideConfirmationOpen}
          toggle={toggleOverrideConfirmation}
          onConfirm={() =>
            handleRemoveProjectOverride(overridePropertyIdentifier)
          }
          message={`${"Are you sure you want to use the Project Settings?"}`}
          headingText={`${"Confirm Remove Override"}`}
        />
        <ConfirmationModal
          isOpen={showUpdateConfirmation}
          toggle={toggleUpdateConfirmation}
          onConfirm={confirmPendingChange}
          message="This will remove all the shutters from this module including the size and color cusomizations. Are you sure?"
          headingText={`${"Change Shutter Type"}`}
        />
        <ConfirmationModal
          isOpen={showRemoveGrooveConfirmation}
          toggle={toggleRemoveGrooveConfirmation}
          onConfirm={() => deleteGroove(removeLight)}
          message="Are you sure you want to remove the light groove?"
          headingText="Remove Light Groove"
        />
        <ConfirmationModal
          isOpen={showClearSpaceConfirmation}
          toggle={toggleClearSpaceConfirmation}
          onConfirm={() => handleClearRootSpace()}
          message="Are you sure you want to clear the space in this module?"
          headingText="Clear space in module"
        />
      </div>
    </>
  );
};
export default MultiUpdateModal;
